import { AlertDisplay, OAuthRequestDialog } from '@backstage/core-components';
import { createApp } from '@backstage/app-defaults';
import { AppRouter, FlatRoutes } from '@backstage/core-app-api';
import {
  defaultAppComponents,
  bindDefaultRoutes,
  routes as defaultRoutes,
  VisitListener,
} from '@platt-internal/backstage-plugin-bootstrap-react';
import { SignalsDisplay } from '@backstage/plugin-signals';
import { apis } from './apis';
import { entityPage } from './components/catalog/EntityPage';
import { Root } from './components/Root';

const app = createApp({
  apis,
  components: {  
    ...defaultAppComponents,
  },
  bindRoutes({ bind }) {  
    bindDefaultRoutes({ bind });
  },
});

const routes = (
  <FlatRoutes>
    {defaultRoutes({ entityPage })}

    {/* additional routes */}
  </FlatRoutes>

);

export default app.createRoot(
  <>
    <AlertDisplay />
    <OAuthRequestDialog />
    <SignalsDisplay />    
    <AppRouter>
      <VisitListener />
      <Root>{routes}</Root>
    </AppRouter>
  </>,
);
